export function normalizeTraceHtml(html: string): string {
  if (!html) { return ''; }
  return html
    .replace(/<br>\s*<table>/gi, '')
    .replace(/<\/tr>\s*<br>/gi, '</tr>')
    .replace(/(<br\s*\/?>\s*){2,}/gi, '<br>')
    .replace(/\s{2,}/g, ' ')
    .trim();
}

export function toValidId(value: unknown): number | null {
  const asNumber = parseNumber(value);
  return Number.isFinite(asNumber) && asNumber > 0 ? asNumber : null;
};

export function parseNumber(value: unknown, defaultValue = 0): number {
  const asNumber = toNumber(value);
  return asNumber ?? defaultValue;
}

export function toNumber(value: unknown): number | null {
  if (value === null || value === undefined || value === '') { return null; }
  if (typeof value === 'number') { return Number.isFinite(value) ? value : null; }
  if (typeof value === 'string') {
    const asString = value.trim();
    if (asString === '') { return null; }
    const asNumber = Number(asString);
    return Number.isFinite(asNumber) ? asNumber : null;
  }
  return null;
}

export function toBooleanStrict(value: unknown): boolean {
  if (typeof value === 'boolean') { return value; }
  if (typeof value === 'number') { return value === 1; }
  const s = value === null || typeof value === 'undefined' ? '' : String(value).trim().toLowerCase();
  return s === 'true' || s === '1' || s === 'sí' || s === 'si' || s === 'yes' || s === 'y';
}

export function toISO(value: unknown): string | null {
  if (value === null || value === undefined || value === '') { return null; }
  const asDate = value instanceof Date ? value : new Date(value as any);
  return Number.isNaN(asDate.getTime()) ? null : asDate.toISOString();
}

export function toISODateOnly(value: unknown): string {
  if (value === null || typeof value === 'undefined') { return ''; }
  const asDate = value instanceof Date ? value : new Date(value as any);
  if (Number.isNaN(asDate.getTime())) { return ''; }
  const year = asDate.getFullYear();
  const month = String(asDate.getMonth() + 1).padStart(2, '0');
  const day = String(asDate.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
